import React from 'react';
import { BookOpen, Users, BarChart, ArrowRight } from 'lucide-react';
export const Approach = () => {
  return <section id="approach" className="py-16 md:py-24 bg-white" data-id="element-41">
      <div className="container mx-auto px-4" data-id="element-42">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-44">
            Our Delivery Approach
          </h2>
          <p className="text-lg text-gray-600" data-id="element-45">
            We believe in flexibility. That's why we've developed three distinct
            service models to meet you exactly where you are in your journey.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-46">
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200 hover:border-blue-500 transition flex flex-col" data-id="element-47">
            <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-48">
              <BookOpen className="text-blue-800" size={28} data-id="element-49" />
            </div>
            <h3 className="text-xl font-bold text-center text-gray-900 mb-4" data-id="element-50">
              DIY
            </h3>
            <p className="text-gray-600 text-center mb-6" data-id="element-51">
              We equip you with the tools, frameworks, and knowledge to
              implement strategies on your own.
            </p>
            <ul className="space-y-3 text-gray-700 mb-8" data-id="element-52">
              <li className="flex items-start" data-id="element-53">
                <span className="text-blue-500 mr-2" data-id="element-54">✓</span>
                <span data-id="element-55">Strategic frameworks & templates</span>
              </li>
              <li className="flex items-start" data-id="element-56">
                <span className="text-blue-500 mr-2" data-id="element-57">✓</span>
                <span data-id="element-58">Self-paced learning resources</span>
              </li>
              <li className="flex items-start" data-id="element-59">
                <span className="text-blue-500 mr-2" data-id="element-60">✓</span>
                <span data-id="element-61">Advisory check-ins</span>
              </li>
              <li className="flex items-start" data-id="element-62">
                <span className="text-blue-500 mr-2" data-id="element-63">✓</span>
                <span data-id="element-64">Implementation guides</span>
              </li>
            </ul>
            <div className="mt-auto" data-id="element-65">
              <div className="mb-4 text-center" data-id="element-66">
                <p className="text-sm text-gray-500 italic" data-id="element-67">
                  Perfect for self-starters with capable teams looking for
                  strategic direction
                </p>
              </div>
              <a href="https://selar.com/m/lifefortsolutions" className="bg-blue-800 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-md transition w-full flex items-center justify-center" target="_blank" rel="noopener noreferrer" data-id="element-68">
                Get Started
                <ArrowRight size={18} className="ml-2" data-id="element-69" />
              </a>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200 hover:border-blue-500 transition md:-mt-4 relative flex flex-col" data-id="element-70">
            <div className="absolute -top-4 left-0 right-0 flex justify-center" data-id="element-71">
              <span className="bg-blue-800 text-white text-xs uppercase font-bold py-1 px-3 rounded-full" data-id="element-72">
                Most Popular
              </span>
            </div>
            <div className="bg-amber-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-73">
              <Users className="text-amber-600" size={28} data-id="element-74" />
            </div>
            <h3 className="text-xl font-bold text-center text-gray-900 mb-4" data-id="element-75">
              HYBRID
            </h3>
            <p className="text-gray-600 text-center mb-6" data-id="element-76">
              A collaborative approach where we work alongside your team to
              develop and execute strategies.
            </p>
            <ul className="space-y-3 text-gray-700 mb-8" data-id="element-77">
              <li className="flex items-start" data-id="element-78">
                <span className="text-amber-500 mr-2" data-id="element-79">✓</span>
                <span data-id="element-80">Co-creation workshops</span>
              </li>
              <li className="flex items-start" data-id="element-81">
                <span className="text-amber-500 mr-2" data-id="element-82">✓</span>
                <span data-id="element-83">Capability building</span>
              </li>
              <li className="flex items-start" data-id="element-84">
                <span className="text-amber-500 mr-2" data-id="element-85">✓</span>
                <span data-id="element-86">Shared implementation</span>
              </li>
              <li className="flex items-start" data-id="element-87">
                <span className="text-amber-500 mr-2" data-id="element-88">✓</span>
                <span data-id="element-89">Progress tracking & coaching</span>
              </li>
            </ul>
            <div className="mt-auto" data-id="element-90">
              <div className="mb-4 text-center" data-id="element-91">
                <p className="text-sm text-gray-500 italic" data-id="element-92">
                  Ideal for organizations wanting to build internal capacity
                  while ensuring results
                </p>
              </div>
              <a href="#contact" className="bg-amber-500 hover:bg-amber-600 text-blue-900 font-medium px-6 py-3 rounded-md transition w-full flex items-center justify-center" data-id="element-93">
                Get In Touch
                <ArrowRight size={18} className="ml-2" data-id="element-94" />
              </a>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200 hover:border-blue-500 transition flex flex-col" data-id="element-95">
            <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-96">
              <BarChart className="text-green-700" size={28} data-id="element-97" />
            </div>
            <h3 className="text-xl font-bold text-center text-gray-900 mb-4" data-id="element-98">
              DFY (Done For You)
            </h3>
            <p className="text-gray-600 text-center mb-6" data-id="element-99">
              We take full ownership of strategy development and execution,
              delivering turnkey solutions.
            </p>
            <ul className="space-y-3 text-gray-700 mb-8" data-id="element-100">
              <li className="flex items-start" data-id="element-101">
                <span className="text-green-600 mr-2" data-id="element-102">✓</span>
                <span data-id="element-103">Full-service implementation</span>
              </li>
              <li className="flex items-start" data-id="element-104">
                <span className="text-green-600 mr-2" data-id="element-105">✓</span>
                <span data-id="element-106">Dedicated project team</span>
              </li>
              <li className="flex items-start" data-id="element-107">
                <span className="text-green-600 mr-2" data-id="element-108">✓</span>
                <span data-id="element-109">End-to-end management</span>
              </li>
              <li className="flex items-start" data-id="element-110">
                <span className="text-green-600 mr-2" data-id="element-111">✓</span>
                <span data-id="element-112">Comprehensive reporting</span>
              </li>
            </ul>
            <div className="mt-auto" data-id="element-113">
              <div className="mb-4 text-center" data-id="element-114">
                <p className="text-sm text-gray-500 italic" data-id="element-115">
                  Best for busy leaders who want expert execution without
                  operational burden
                </p>
              </div>
              <a href="#contact" className="bg-green-600 hover:bg-green-700 text-white font-medium px-6 py-3 rounded-md transition w-full flex items-center justify-center" data-id="element-116">
                Get In Touch
                <ArrowRight size={18} className="ml-2" data-id="element-117" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};